import { FormControl, TextField, InputLabel } from "@mui/material";
import { Controller } from "react-hook-form";

export const Fields = ({ control, inputLlabel, name, placeholder, type }) => {
  return (
    <>
      <InputLabel htmlFor="store-branch"> {inputLlabel} </InputLabel>
      <FormControl fullWidth>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              placeholder={placeholder}
              type={type}
              style={{ width: "100%" }}
            />
          )}
        />
      </FormControl>
    </>
  );
};
